import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TokenVerification from './pages/TokenVerification';

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TokenVerification />} />
      </Routes>
    </BrowserRouter>
  );
};